// localStorage wrapper for the "last Okoshi session" footer shown on the
// idle screen (spec U-OKO-6).

const STORAGE_KEY = "koe.okoshi.lastSession";

export interface OkoshiLastSession {
  savedPath: string;
  durationSec: number;
  charCount: number;
  savedAt: number; // epoch ms
}

export function readLastSession(): OkoshiLastSession | null {
  try {
    const raw = window.localStorage.getItem(STORAGE_KEY);
    if (!raw) return null;
    const parsed = JSON.parse(raw) as Partial<OkoshiLastSession>;
    if (
      typeof parsed.savedPath !== "string" ||
      typeof parsed.durationSec !== "number" ||
      typeof parsed.charCount !== "number" ||
      typeof parsed.savedAt !== "number"
    ) {
      return null;
    }
    return parsed as OkoshiLastSession;
  } catch {
    // Private browsing, quota, JSON parse — any failure collapses to null.
    return null;
  }
}

export function writeLastSession(entry: OkoshiLastSession): void {
  try {
    window.localStorage.setItem(STORAGE_KEY, JSON.stringify(entry));
  } catch {
    /* ignore quota / private browsing */
  }
}

/** Format duration in `Nm SSs` (e.g. "6m 12s") — matches spec §1.3 wording. */
export function formatDuration(sec: number): string {
  const total = Math.max(0, Math.floor(sec));
  const minutes = Math.floor(total / 60);
  const seconds = total % 60;
  return `${minutes}m ${String(seconds).padStart(2, "0")}s`;
}
